import { gql, useQuery } from '@apollo/client';

export const GET_COMPANY_BY_DATEV_NUMBER = gql`
  query getCompanyByDatevNumber($datevNumberId: ObjectId!) {
    getCompanyByDatevNumber(datevNumberId: $datevNumberId) {
      _id
      name
    }
  }
`;

export const useGetCompanyByDatevNumber = (datevNumberId: string) => {
  const { data, loading } = useQuery(GET_COMPANY_BY_DATEV_NUMBER, {
    variables: { datevNumberId },
    skip: !datevNumberId,
  });

  const company = data?.getCompanyByDatevNumber || {};

  return { company, loading };
};
